(function () {
    const root = document.querySelector('[data-article-directory]');
    if (!root) {
        return;
    }

    const form = root.querySelector('[data-article-filters]');
    const list = root.querySelector('[data-article-list]');
    const results = root.querySelector('[data-article-filter-results]');
    const emptyState = root.querySelector('[data-article-no-results]');
    const status = root.querySelector('[data-article-status]');
    const statusMessage = root.querySelector('[data-article-status-message]');
    const pagination = root.querySelector('[data-article-pagination]');
    const paginationSummary = root.querySelector('[data-article-pagination-summary]');
    const prevButton = root.querySelector('[data-article-prev]');
    const nextButton = root.querySelector('[data-article-next]');
    const retryButton = root.querySelector('[data-article-retry]');

    if (!form || !list || !results || !emptyState || !status || !statusMessage || !pagination || !paginationSummary || !prevButton || !nextButton) {
        return;
    }

    const apiOrigin = root.dataset.apiOrigin || window.location.origin;
    const apiKey = root.dataset.apiKey || '';
    const pageSize = Math.max(parseInt(root.dataset.pageSize, 10) || 25, 1);

    const seriesInput = form.querySelector('[name="series"]');
    const authorInput = form.querySelector('[name="author"]');
    const searchInput = form.querySelector('[name="q"]');
    const rangePicker = form.querySelector('[data-range-picker]');
    const rangeTrigger = form.querySelector('[data-range-trigger]');
    const rangeTriggerLabel = form.querySelector('[data-range-trigger-label]');
    const rangePopover = form.querySelector('[data-range-popover]');
    const rangeStartInput = form.querySelector('[data-range-start]');
    const rangeEndInput = form.querySelector('[data-range-end]');
    const rangeApplyButton = form.querySelector('[data-range-apply]');
    const rangeClearButton = form.querySelector('[data-range-clear]');
    const startInput = form.querySelector('[data-range-start-value]');
    const endInput = form.querySelector('[data-range-end-value]');

    const collator = typeof Intl !== 'undefined'
        ? new Intl.Collator(undefined, {sensitivity: 'base'})
        : null;
    const dateFormatter = typeof Intl !== 'undefined'
        ? new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            timeZone: 'UTC'
        })
        : null;

    const seriesMap = {
        lab: 'The Lab',
        studio: 'The Studio',
        people: 'The People'
    };

    const excludedTopicTags = Object.keys(seriesMap);

    let searchTimer = null;
    let activeRequestId = 0;
    let state = {
        page: 1,
        totalPages: 1,
        totalPosts: 0,
        filters: {
            series: '',
            author: '',
            start: '',
            end: '',
            q: ''
        }
    };

    function escapeNqlString(value) {
        return String(value || '')
            .replace(/\\/g, '\\\\')
            .replace(/"/g, '\\"')
            .replace(/'/g, '\\\'');
    }

    function canonicalSeries(value) {
        return Object.prototype.hasOwnProperty.call(seriesMap, value) ? value : '';
    }

    function compareByName(left, right) {
        if (collator) {
            return collator.compare(left.name, right.name);
        }

        return left.name.localeCompare(right.name);
    }

    function getSeriesTag(post) {
        if (!post || !Array.isArray(post.tags)) {
            return null;
        }

        for (const seriesSlug of Object.keys(seriesMap)) {
            const matchingTag = post.tags.find(function (tag) {
                return tag && tag.slug === seriesSlug;
            });

            if (matchingTag) {
                return matchingTag;
            }
        }

        return null;
    }

    function setStatus(message, tone) {
        status.hidden = false;
        status.dataset.tone = tone || 'info';
        statusMessage.textContent = message;
    }

    function hideStatus() {
        status.hidden = true;
        delete status.dataset.tone;
        statusMessage.textContent = '';
    }

    function setFormDisabled(isDisabled) {
        Array.from(form.elements).forEach(function (field) {
            field.disabled = isDisabled;
        });

        if (isDisabled) {
            closeRangePicker(false);
        }
    }

    function syncDateBounds() {
        if (!rangeStartInput || !rangeEndInput) {
            return;
        }

        rangeStartInput.max = rangeEndInput.value || '';
        rangeEndInput.min = rangeStartInput.value || '';
    }

    function normalizeDateRange(start, end) {
        if (start && end && start > end) {
            return {
                start: end,
                end: start
            };
        }

        return {
            start: start || '',
            end: end || ''
        };
    }

    function formatDateForDisplay(value) {
        if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return '';
        }

        const parts = value.split('-').map(function (segment) {
            return parseInt(segment, 10);
        });
        const displayDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));

        return dateFormatter ? dateFormatter.format(displayDate) : value;
    }

    function updateRangeTriggerLabel() {
        if (!rangeTrigger || !rangeTriggerLabel) {
            return;
        }

        const start = startInput ? startInput.value : '';
        const end = endInput ? endInput.value : '';
        let label = 'Any date';

        if (start && end) {
            label = formatDateForDisplay(start) + ' - ' + formatDateForDisplay(end);
        } else if (start) {
            label = 'From ' + formatDateForDisplay(start);
        } else if (end) {
            label = 'Until ' + formatDateForDisplay(end);
        }

        rangeTriggerLabel.textContent = label;
        rangeTrigger.classList.toggle('is-placeholder', !(start || end));
    }

    function syncRangePickerFromValues() {
        if (rangeStartInput) {
            rangeStartInput.value = startInput ? startInput.value : '';
        }

        if (rangeEndInput) {
            rangeEndInput.value = endInput ? endInput.value : '';
        }

        syncDateBounds();
        updateRangeTriggerLabel();
    }

    function closeRangePicker(shouldFocusTrigger) {
        if (!rangePopover || rangePopover.hidden) {
            return;
        }

        rangePopover.hidden = true;

        if (rangeTrigger) {
            rangeTrigger.setAttribute('aria-expanded', 'false');
        }

        if (shouldFocusTrigger && rangeTrigger) {
            rangeTrigger.focus();
        }
    }

    function openRangePicker() {
        if (!rangePopover) {
            return;
        }

        syncRangePickerFromValues();
        rangePopover.hidden = false;

        if (rangeTrigger) {
            rangeTrigger.setAttribute('aria-expanded', 'true');
        }

        if (rangeStartInput) {
            rangeStartInput.focus();
        }
    }

    function setRangeValues(start, end) {
        const normalized = normalizeDateRange(start, end);

        if (startInput) {
            startInput.value = normalized.start;
        }

        if (endInput) {
            endInput.value = normalized.end;
        }

        syncRangePickerFromValues();
    }

    function applyRangeSelection() {
        setRangeValues(
            rangeStartInput ? rangeStartInput.value : '',
            rangeEndInput ? rangeEndInput.value : ''
        );
        closeRangePicker(true);
        resetToFirstPageAndLoad();
    }

    function populateSelect(select, options, selectedValue) {
        if (!select) {
            return;
        }

        const defaultLabel = select.dataset.defaultLabel || 'All';
        const fragment = document.createDocumentFragment();

        options.forEach(function (optionData) {
            const option = document.createElement('option');
            option.value = optionData.slug;
            option.textContent = optionData.name;
            fragment.appendChild(option);
        });

        select.innerHTML = '';

        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = defaultLabel;
        select.appendChild(defaultOption);
        select.appendChild(fragment);

        if (selectedValue && options.some(function (optionData) { return optionData.slug === selectedValue; })) {
            select.value = selectedValue;
        } else {
            select.value = '';
        }

        select.disabled = options.length === 0;
    }

    function buildApiUrl(resource, params) {
        const url = new URL('/ghost/api/content/' + resource + '/', apiOrigin);
        url.searchParams.set('key', apiKey);

        Object.keys(params || {}).forEach(function (key) {
            const value = params[key];

            if (value !== undefined && value !== null && value !== '') {
                url.searchParams.set(key, value);
            }
        });

        return url;
    }

    async function fetchJson(resource, params) {
        const response = await fetch(buildApiUrl(resource, params).toString(), {
            credentials: 'omit'
        });

        let payload = null;

        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }

        if (!response.ok) {
            const errorMessage = payload && payload.errors && payload.errors[0] && payload.errors[0].message
                ? payload.errors[0].message
                : 'Ghost returned an unexpected response.';

            throw new Error(errorMessage);
        }

        return payload;
    }

    async function fetchAllPages(resource, params) {
        const allItems = [];
        let page = 1;
        let totalPages = 1;

        while (page <= totalPages) {
            const payload = await fetchJson(resource, Object.assign({}, params, {
                page: page,
                limit: 100
            }));

            const items = payload[resource] || [];
            const meta = payload.meta && payload.meta.pagination ? payload.meta.pagination : {};

            allItems.push.apply(allItems, items);
            totalPages = meta.pages || 1;
            page += 1;
        }

        return allItems;
    }

    function parseUrlState() {
        const params = new URLSearchParams(window.location.search);
        const normalizedRange = normalizeDateRange(
            /^\d{4}-\d{2}-\d{2}$/.test(params.get('start') || '') ? params.get('start') : '',
            /^\d{4}-\d{2}-\d{2}$/.test(params.get('end') || '') ? params.get('end') : ''
        );

        return {
            page: Math.max(parseInt(params.get('page'), 10) || 1, 1),
            filters: {
                series: canonicalSeries(params.get('series') || ''),
                author: params.get('author') || '',
                start: normalizedRange.start,
                end: normalizedRange.end,
                q: params.get('q') || ''
            }
        };
    }

    function applyStateToForm(nextState) {
        if (seriesInput) {
            seriesInput.value = nextState.filters.series;
        }

        if (startInput) {
            startInput.value = nextState.filters.start;
        }

        if (endInput) {
            endInput.value = nextState.filters.end;
        }

        if (searchInput) {
            searchInput.value = nextState.filters.q;
        }

        syncRangePickerFromValues();
    }

    function readFiltersFromForm() {
        const normalizedRange = normalizeDateRange(
            startInput ? startInput.value : '',
            endInput ? endInput.value : ''
        );

        return {
            series: seriesInput ? canonicalSeries(seriesInput.value) : '',
            author: authorInput ? authorInput.value : '',
            start: normalizedRange.start,
            end: normalizedRange.end,
            q: searchInput ? searchInput.value.trim() : ''
        };
    }

    function updateUrlFromState(nextState) {
        if (!window.history || !window.history.replaceState) {
            return;
        }

        const url = new URL(window.location.href);

        [
            ['series', nextState.filters.series],
            ['author', nextState.filters.author],
            ['start', nextState.filters.start],
            ['end', nextState.filters.end],
            ['q', nextState.filters.q]
        ].forEach(function (entry) {
            const key = entry[0];
            const value = entry[1];

            if (value) {
                url.searchParams.set(key, value);
            } else {
                url.searchParams.delete(key);
            }
        });

        if (nextState.page > 1) {
            url.searchParams.set('page', String(nextState.page));
        } else {
            url.searchParams.delete('page');
        }

        window.history.replaceState({}, '', url);
    }

    function normalizeSearchValue(value) {
        return String(value || '').trim().toLocaleLowerCase();
    }

    function postMatchesSearch(post, rawQuery) {
        const query = normalizeSearchValue(rawQuery);
        if (!query) {
            return true;
        }

        const fields = [
            post.title,
            post.custom_excerpt,
            post.excerpt,
            post.slug
        ];

        (post.authors || []).forEach(function (author) {
            fields.push(author.name, author.slug);
        });

        (post.tags || []).forEach(function (tag) {
            fields.push(tag.name, tag.slug);
        });

        return fields.some(function (field) {
            return normalizeSearchValue(field).indexOf(query) !== -1;
        });
    }

    function buildFilterString(filters) {
        const parts = [];

        if (filters.series) {
            parts.push('tag:' + filters.series);
        }

        if (filters.author) {
            parts.push('authors.slug:' + filters.author);
        }

        if (filters.start) {
            parts.push('published_at:>=\'' + escapeNqlString(filters.start) + '\'');
        }

        if (filters.end) {
            parts.push('published_at:<=\'' + escapeNqlString(filters.end) + '\'');
        }

        return parts.join('+');
    }

    function updateResultsSummary(paginationMeta, filters) {
        const total = paginationMeta.total || 0;
        const hasActiveFilters = Object.keys(filters).some(function (key) {
            return Boolean(filters[key]);
        });

        if (!total) {
            results.textContent = hasActiveFilters ? 'No matching articles' : '0 articles';
            return;
        }

        if (!hasActiveFilters && total <= pageSize && paginationMeta.pages <= 1) {
            results.textContent = total + ' articles';
            return;
        }

        const start = (paginationMeta.page - 1) * paginationMeta.limit + 1;
        const end = Math.min(start + paginationMeta.limit - 1, total);

        results.textContent = 'Showing ' + start + '–' + end + ' of ' + total + ' articles';
    }

    function renderPagination(paginationMeta) {
        const totalPages = paginationMeta.pages || 1;
        const currentPage = paginationMeta.page || 1;

        pagination.hidden = totalPages <= 1;
        paginationSummary.textContent = 'Page ' + currentPage + ' of ' + totalPages;
        prevButton.disabled = currentPage <= 1;
        nextButton.disabled = currentPage >= totalPages;
    }

    function createMetaItem(tagName, className, text) {
        const element = document.createElement(tagName);
        element.className = className;
        element.textContent = text;
        return element;
    }

    function renderArticles(posts) {
        const fragment = document.createDocumentFragment();

        posts.forEach(function (post) {
            const article = document.createElement('article');
            article.className = 'ai-article-list-item';

            const meta = document.createElement('div');
            meta.className = 'ai-article-list-meta';

            const seriesTag = getSeriesTag(post);
            const displayTag = seriesTag || post.primary_tag;

            if (displayTag) {
                const seriesLink = document.createElement('a');
                seriesLink.className = 'ai-article-list-tag';
                seriesLink.href = seriesTag ? '/' + seriesTag.slug + '/' : displayTag.url;
                seriesLink.textContent = displayTag.name;
                meta.appendChild(seriesLink);
            }

            if (post.published_at) {
                const publishedDate = new Date(post.published_at);
                const time = createMetaItem('time', 'ai-article-list-date', publishedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }));
                time.dateTime = post.published_at.slice(0, 10);
                meta.appendChild(time);
            }

            if (post.reading_time) {
                meta.appendChild(createMetaItem('span', 'ai-article-list-length', post.reading_time + ' min read'));
            }

            article.appendChild(meta);

            const title = document.createElement('h3');
            title.className = 'ai-article-list-title';

            const titleLink = document.createElement('a');
            titleLink.href = post.url;
            titleLink.textContent = post.title;
            title.appendChild(titleLink);
            article.appendChild(title);

            const excerpt = post.custom_excerpt || post.excerpt;
            if (excerpt) {
                const excerptNode = document.createElement('p');
                excerptNode.className = 'ai-article-list-excerpt';
                excerptNode.textContent = excerpt;
                article.appendChild(excerptNode);
            }

            const primaryTopicSlug = seriesTag ? '' : (post.primary_tag && post.primary_tag.slug);
            const topicTags = (post.tags || []).filter(function (tag) {
                return tag.slug !== primaryTopicSlug && excludedTopicTags.indexOf(tag.slug) === -1;
            });

            if (topicTags.length) {
                const topics = document.createElement('div');
                topics.className = 'ai-article-list-topics';

                topicTags.forEach(function (tag) {
                    const tagLink = document.createElement('a');
                    tagLink.className = 'ai-article-list-topic-tag';
                    tagLink.href = tag.url;
                    tagLink.textContent = tag.name;
                    topics.appendChild(tagLink);
                });

                article.appendChild(topics);
            }

            if (post.authors && post.authors.length) {
                const authors = document.createElement('p');
                authors.className = 'ai-article-list-authors';

                authors.appendChild(document.createTextNode('By '));

                post.authors.forEach(function (author, index) {
                    if (index > 0) {
                        authors.appendChild(document.createTextNode(', '));
                    }

                    const authorLink = document.createElement('a');
                    authorLink.href = author.url;
                    authorLink.textContent = author.name;
                    authors.appendChild(authorLink);
                });

                article.appendChild(authors);
            }

            fragment.appendChild(article);
        });

        list.replaceChildren(fragment);
    }

    function showNoResults() {
        list.replaceChildren();
        emptyState.hidden = false;
        pagination.hidden = true;
    }

    function hideNoResults() {
        emptyState.hidden = true;
    }

    async function loadDirectoryOptions() {
        const authorPromise = fetchAllPages('authors', {
            include: 'count.posts',
            order: 'name asc'
        });

        const authors = (await authorPromise)
            .map(function (author) {
                return {
                    slug: author.slug,
                    name: author.name
                };
            })
            .sort(compareByName);

        populateSelect(authorInput, authors, state.filters.author);
    }

    async function loadArticles() {
        const requestId = activeRequestId + 1;
        activeRequestId = requestId;

        const filters = readFiltersFromForm();
        state.filters = filters;
        syncDateBounds();
        updateUrlFromState(state);

        list.setAttribute('aria-busy', 'true');
        hideNoResults();
        setStatus('Loading articles…', 'info');

        if (retryButton) {
            retryButton.hidden = true;
        }

        try {
            let posts = [];
            let paginationMeta = null;

            if (filters.q) {
                const matchingPosts = (await fetchAllPages('posts', {
                    include: 'authors,tags',
                    order: 'published_at desc',
                    filter: buildFilterString(filters)
                })).filter(function (post) {
                    return postMatchesSearch(post, filters.q);
                });

                const totalPages = Math.max(Math.ceil(matchingPosts.length / pageSize), 1);

                if (state.page > totalPages) {
                    state.page = totalPages;
                    loadArticles();
                    return;
                }

                const startIndex = (state.page - 1) * pageSize;
                posts = matchingPosts.slice(startIndex, startIndex + pageSize);
                paginationMeta = {
                    page: state.page,
                    pages: totalPages,
                    total: matchingPosts.length,
                    limit: pageSize
                };
            } else {
                const payload = await fetchJson('posts', {
                    include: 'authors,tags',
                    limit: pageSize,
                    page: state.page,
                    order: 'published_at desc',
                    filter: buildFilterString(filters)
                });

                posts = payload.posts || [];
                paginationMeta = payload.meta && payload.meta.pagination ? payload.meta.pagination : {
                    page: state.page,
                    pages: 1,
                    total: posts.length,
                    limit: pageSize
                };
            }

            if (requestId !== activeRequestId) {
                return;
            }

            if (paginationMeta.pages && state.page > paginationMeta.pages) {
                state.page = paginationMeta.pages;
                loadArticles();
                return;
            }

            state.totalPages = paginationMeta.pages || 1;
            state.totalPosts = paginationMeta.total || 0;

            updateResultsSummary(paginationMeta, filters);
            renderPagination(paginationMeta);

            if (!posts.length) {
                showNoResults();
            } else {
                renderArticles(posts);
                hideNoResults();
            }

            hideStatus();
        } catch (error) {
            if (requestId !== activeRequestId) {
                return;
            }

            pagination.hidden = true;
            hideNoResults();
            results.textContent = list.children.length ? 'Showing latest saved articles' : 'Unable to load articles';
            setStatus((error.message || 'Unable to load articles right now.') + ' The latest server-rendered articles remain available below.', 'error');

            if (retryButton) {
                retryButton.hidden = false;
            }
        } finally {
            if (requestId === activeRequestId) {
                list.setAttribute('aria-busy', 'false');
            }
        }
    }

    function resetToFirstPageAndLoad() {
        state.page = 1;
        loadArticles();
    }

    function handleSearchInput() {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
            resetToFirstPageAndLoad();
        }, 250);
    }

    function initialisePaginationHandlers() {
        prevButton.addEventListener('click', function () {
            if (state.page <= 1) {
                return;
            }

            state.page -= 1;
            loadArticles();
        });

        nextButton.addEventListener('click', function () {
            if (state.page >= state.totalPages) {
                return;
            }

            state.page += 1;
            loadArticles();
        });
    }

    async function initialiseDirectory() {
        state = Object.assign(state, parseUrlState());
        applyStateToForm(state);
        initialisePaginationHandlers();

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            resetToFirstPageAndLoad();
        });

        form.addEventListener('reset', function () {
            window.requestAnimationFrame(function () {
                state.page = 1;
                state.filters = {
                    series: '',
                    author: '',
                    start: '',
                    end: '',
                    q: ''
                };
                closeRangePicker(false);
                syncRangePickerFromValues();
                loadArticles();

                if (searchInput) {
                    searchInput.focus();
                }
            });
        });

        if (searchInput) {
            searchInput.addEventListener('input', handleSearchInput);
        }

        if (retryButton) {
            retryButton.addEventListener('click', function () {
                loadArticles();
            });
        }

        [seriesInput, authorInput].forEach(function (field) {
            if (!field) {
                return;
            }

            field.addEventListener('change', function () {
                resetToFirstPageAndLoad();
            });
        });

        if (rangeTrigger && rangePopover) {
            rangeTrigger.addEventListener('click', function () {
                if (rangePopover.hidden) {
                    openRangePicker();
                } else {
                    closeRangePicker(false);
                }
            });
        }

        [rangeStartInput, rangeEndInput].forEach(function (field) {
            if (!field) {
                return;
            }

            field.addEventListener('change', function () {
                syncDateBounds();
            });

            field.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    applyRangeSelection();
                }
            });
        });

        if (rangeApplyButton) {
            rangeApplyButton.addEventListener('click', function () {
                applyRangeSelection();
            });
        }

        if (rangeClearButton) {
            rangeClearButton.addEventListener('click', function () {
                setRangeValues('', '');
                closeRangePicker(true);
                resetToFirstPageAndLoad();
            });
        }

        document.addEventListener('click', function (event) {
            if (!rangePicker || !rangePopover || rangePopover.hidden) {
                return;
            }

            if (!rangePicker.contains(event.target)) {
                closeRangePicker(false);
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && rangePopover && !rangePopover.hidden) {
                event.preventDefault();
                closeRangePicker(true);
            }
        });

        if (!apiKey) {
            setFormDisabled(true);
            results.textContent = 'Articles API not configured';
            setStatus('Add a Ghost Content API key in this theme’s Articles settings to load the archive.', 'error');
            return;
        }

        try {
            await loadDirectoryOptions();
            loadArticles();
        } catch (error) {
            setFormDisabled(true);
            results.textContent = 'Unable to load filters';
            setStatus(error.message || 'Unable to load article filters right now.', 'error');
        }
    }

    initialiseDirectory();
})();
